import styled from "styled-components/macro";
import { device } from "../../../device";

export const StyledAudiencesContainer = styled.div`
	padding: 0px;
	margin: 24px 0;
	width: 100%;
	/* width: 50vw; */
`;
export const StyledTableContainer = styled.div`
	width: 50vw;
`;

export const StyledAudiencesTitle = styled.div`
	font-weight: 600;
	font-size: 24px;
	line-height: 36px;

	color: #575e68;

	margin: 14px 0;
	display: flex;
	gap: 1rem;
	@media ${device.mobileL} {
		font-size: 20px;
		line-height: 30px;
	}
	@media ${device.mobileS} {
		font-size: 18px;
		line-height: 26px;
	}

	a {
		display: inline-block;
		width: 24px;
		color: #575e68;
	}
`;
// integrate Facebook message
export const StyledIntegrateFMsgContainer = styled.div`
	padding: 24px;
	margin: 24px 0;
	background: #ffffff;
	border: 1px solid #ebedee;
	border-radius: 8px;

	display: flex;
	align-items: center;

	@media ${device.tablet} {
		padding: 0;
		margin: 0;
		flex-wrap: wrap;
		justify-content: center;
		text-align: center;
	}
`;
export const IntegrateFMsgContainer = styled.div`
	padding: 24px;
	margin: 24px 0;
	width: 100%;
	background: #ffffff;
	border: 1px solid #ebedee;
	border-radius: 8px;

	display: flex;
	align-items: center;
	gap: 30px;

	@media ${device.tablet} {
		flex-direction: column;
		gap: 0;
	}
`;
export const StyledSolvingProblemsIlustrationContainer = styled.div`
	padding: 1rem;
	padding-right: 2rem;
`;

export const StyledInnerIntegrateFMsg = styled.div`
	text-align: left;
	${"" /* margin: 14px 40px; */}
	h3 {
		font-weight: 600;
		font-size: 24px;
		line-height: 36px;
		color: #575e68;
		margin: 14px 0;
		@media ${device.mobileL} {
			font-size: 22px;
			line-height: 34px;
			margin: 12px 0;
		}
	}
	p {
		font-size: 16px;
		line-height: 24px;
		color: #575e68;
		margin: 14px 0;
		@media ${device.mobileL} {
			font-size: 14px;
			line-height: 22px;
			margin: 10px 0;
		}
	}
	button {
		padding: 10px 21px;
		background: #6270c6;
		border: 1px solid #939dd6;
		border-radius: 4px;

		font-weight: 600;
		font-size: 16px;
		line-height: 16px;
		color: #fcfcfd;
		&:hover {
			cursor: pointer;
		}
		@media ${device.mobileL} {
			font-size: 14px;
			line-height: 14px;
		}
	}
	a {
		display: inline-block;
		text-decoration: none;
		padding: 7px 21px;
		background: #6270c6;
		border: 1px solid #939dd6;
		border-radius: 4px;

		font-weight: 600;
		font-size: 16px;
		line-height: 16px;
		color: #fcfcfd;
		&:hover {
			cursor: pointer;
		}
		margin-top: 14px;
		@media ${device.mobileL} {
			font-size: 14px;
			line-height: 14px;
			margin-top: 12px;
		}
	}
`;
